import { mapMutations, mapGetters } from 'vuex';
import * as Mutations from '@/store/modules/header/mutations';

export const headerToolsMixin = (data) => ({
    computed: {
        ...mapGetters(['ability'])
    },
    methods: {
        ...mapMutations({
            updateHeaderToolComponent: Mutations.UPDATE_TOOL_COMPONENT
        }),
    },
    mounted() {
        const checkedData = this.ability.can(data.permission.rules, data.permission.name) ? data : null;

        this.updateHeaderToolComponent(checkedData);
    },
    beforeDestroy() {
        this.updateHeaderToolComponent();
    }
});


// WEBPACK FOOTER //
// ./src/mixins/headerToolsMixin.js